import { supabase } from './supabaseClient';

// Configuration : true pour utiliser les vraies Edge Functions, false pour simulation
const USE_REAL_STRIPE = true; // Mode réel - redirection vers Stripe Checkout

// Fonction pour créer une session de paiement Stripe
export const createStripePaymentSession = async (packData) => {
  try {
    if (USE_REAL_STRIPE) {
      // Utiliser les vraies Edge Functions Supabase
      console.log('Utilisation des vraies Edge Functions Stripe');

      // Déterminer l'URL de base (pour le mode dev ou prod)
      // On utilise l'URL en dur qui est dans supabaseClient.js pour être sûr
      const baseUrl = 'https://icaqghpgcoapikttehjg.supabase.co';
      const anonKey = 'pk_live_51T8Ttn40yQpYKwuIvjWXo4lZO2ZTuG5BOiLpxa8JjB0a9fwbCR5FbBfk9zlbMSHKJKfgY3WpnV3d1gwNFEW8Wiqu00VGrA48ib';
      
      const { data: { session } } = await supabase.auth.getSession();
      
      const response = await fetch(`${baseUrl}/functions/v1/create-payment-session`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${session?.access_token}`,
          'apikey': anonKey
        },
        body: JSON.stringify({
          ...packData,
          returnUrl: window.location.origin + '/settings' // URL de retour après paiement
        })
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        console.error('Détails erreur Edge Function:', errorData);
        throw new Error(errorData.error || 'Erreur Edge Function');
      }

      return await response.json();
    } else {
      // Simulation pour les tests
      console.log('Simulation de paiement Stripe:', packData);

      const mockSession = {
        id: 'cs_test_' + Math.random().toString(36).substring(2, 15),
        url: 'https://checkout.stripe.com/pay/cs_test_' + Math.random().toString(36).substring(2, 15)
      };

      // Enregistrer la tentative de paiement dans la base de données
      const { data, error } = await supabase
        .from('payments')
        .insert({
          user_id: packData.userId,
          amount: packData.amount,
          credits: packData.credits,
          status: 'completed', // En simulation, on marque directement comme complété
          payment_method: 'stripe',
          description: `Achat ${packData.credits} crédits - ${packData.packName}`,
          stripe_session_id: mockSession.id,
          completed_at: new Date().toISOString()
        });

      if (error) {
        console.error('Erreur enregistrement paiement:', error);
        throw error;
      }

      return mockSession;
    }
  } catch (error) {
    console.error('Erreur createStripePaymentSession:', error);
    throw error;
  }
};

// Fonction pour confirmer un paiement réussi (appelée par webhook)
export const confirmPayment = async (sessionId, paymentIntentId) => {
  try {
    // Mettre à jour le statut du paiement
    const { data: payment, error: paymentError } = await supabase
      .from('payments')
      .update({
        status: 'completed',
        stripe_payment_intent_id: paymentIntentId,
        completed_at: new Date().toISOString()
      })
      .eq('stripe_session_id', sessionId)
      .select()
      .single();

    if (paymentError) {
      console.error('Erreur lors de la mise à jour du paiement:', paymentError);
      throw paymentError;
    }

    // Ajouter les crédits à l'utilisateur (via un trigger ou une fonction)
    // Pour l'instant, on peut le faire manuellement ou via une fonction RPC

    console.log('Paiement confirmé:', payment);
    return payment;
  } catch (error) {
    console.error('Erreur confirmPayment:', error);
    throw error;
  }
};

// Fonction pour obtenir l'historique des paiements d'un utilisateur
export const getPaymentHistory = async (userId) => {
  try {
    const { data, error } = await supabase
      .from('payments')
      .select('*')
      .eq('user_id', userId)
      .gt('amount', 0) // Uniquement les transactions avec un montant > 0
      .order('created_at', { ascending: false });

    if (error) {
      console.error('Erreur lors de la récupération de l\'historique:', error);
      throw error;
    }

    return data;
  } catch (error) {
    console.error('Erreur getPaymentHistory:', error);
    throw error;
  }
};

export { USE_REAL_STRIPE };